module.exports = __webpack_public_path__ + "img/hr-pipe-to-ground-down.1abcc606.png";